import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { massRestoreRoles } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useMassRestoreRoles = () => {
    const queryClient = useQueryClient();
    const { mutate: massRestoreRolesMutate, isPending } = useMutation({
        mutationFn: massRestoreRoles,
        onSuccess: (res) => {
            toast.success(res.message || "Roles restored successfully");
            queryClient.invalidateQueries(["roles"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to restore roles"),
    });
    return { massRestoreRolesMutate, isPending };
};
